import type { DatasetLookupCandidate, LookupCheckResult } from 'src/components/star-grid/datasets/datasetTypes';

/** The three pass/fail checks shown for a lookup: a unique key, a full match, and an unchanged row count. */
export interface LookupChecks {
  readonly unique: boolean;
  /** Share of fact rows that find a matching lookup row, as a 0–1 fraction. */
  readonly match: number;
  readonly rowCountUnchanged: boolean;
}

/** A candidate carries no row counts, so an unchanged count is inferred from a unique key with a full match. */
export function candidateChecks(candidate: DatasetLookupCandidate): LookupChecks {
  return { unique: candidate.unique, match: candidate.match, rowCountUnchanged: candidate.unique && candidate.match >= 1 };
}

/** The checks a `lookup-check` call returns. */
export function resultChecks(result: LookupCheckResult): LookupChecks {
  return { unique: result.unique, match: result.match, rowCountUnchanged: result.rows_unchanged };
}
